export default {"src":"/_next/static/media/outlook.6a6d3da8.svg","height":22,"width":22};